import { el, mount } from 'redom';
import merge from 'lodash/merge';
import { VenumViewer } from './viewer';
import { Engine } from '../../Viewer/engine';

import general_lang from './general_lang.json';
import materials_lang from './materials_lang.json';
import meshes_lang from './meshes_lang.json';

// Parcel doesn't want to use tild here
// import { LOCAL_JSON } from '~/Editor/devConfig';
// import { LOCAL_JSON } from '../../../devConfig';
const LOCAL_JSON = {};

const translations = general_lang.concat(materials_lang, meshes_lang);

const canvasContainer = document.getElementById('container');
const projectJson = {
    container: canvasContainer,
    // id: '61a7504b804ea870fda47323', // Elite
    // id: '64f0a9078c5b30a55c528dd0', // Elite STAGING
    // id: '614204c1b0c1f800043ee87c', // Hammer
    // id: '6128b04c164b7f00043b4e44', // Giant 3
    //! Better to use Giant2 because there is text on it
    id: '6254902c0217b97f40e2049b', // Giant 2
    configuration: true,
    // AR: true
};

const project = merge(projectJson, LOCAL_JSON);

class VenumViewerDev extends VenumViewer {
    loadStudioEngine(callback: (engine: Engine) => void) {
        callback(Engine);
    }
}

const viewer = new VenumViewerDev(project, (venum: Engine) => {
    venum.configurationTranslation.setTranslations(translations);
    // console.log(venum.options);

    venum.toolScreenshot.setSize({ width: 700, height: 700 });
    // venum.setConfigurationByName('Black/White');
    // venum.toolScreenshot.shotViews(null, (images) => {
    //     console.log(images);
    // });

    // setTimeout(() => {
    venum.configurationTechnicalFile.getProductImagesAndVariants((data) => {
        const test = el('img', { src: data });
        mount(document.body, test);
    });
    // }, 5000);

    // venum.configurationVariantMesh.onChange((config) => {
    //     console.log(config);
    // });
    // venum.onExit(() => {
    //     console.log('exit');
    // });
    // venum.onConfirm((data) => {
    //     console.log('conf', data);
    // });

    venum.configurationVariantMesh.setPrice('234 dollars');
    venum.configurationTranslation.setLangage('en');
    venum.configurationVariantMesh.updateTranslations();

    venum.system.scene.executeWhenReady(() => {
        viewer.addThumbTextInput();
        viewer.addPalmTextInput();
    });

    // Test to get camera geometry and set default view
    // window.addEventListener('click', () => {
    //     let system = studio.system
    //     let camera = system.arcCamera
    //     console.log(camera.alpha, camera.beta, camera.radius);
    //     studio.toolScreenshot.shotViews(null, (views) => {
    //         for (const view of views) {
    //             let test = el('img', { src: view });
    //             mount(document.body, test);
    //         }

    //     })
    // })

    // let config;
    // const button = el('div', 'Test Save', {
    //     onclick: () => {
    //         if (!config) {
    //             config = venum.getConfigurationJson();
    //             console.log(config);
    //         } else {
    //             venum.setConfigurationByJson(config);
    //             config = null;
    //         }
    //     }
    // });
    // mount(document.body, button);
});
